import React from 'react'
import PropTypes from 'prop-types'
import fromUnixTime from 'date-fns/fromUnixTime'
import formatDate from 'date-fns/format'
import isValid from 'date-fns/isValid'

const FormattedDate = ({timestamp, format}) => {
  if (!timestamp) return null
  const date = fromUnixTime(timestamp)

  if (!isValid(date)) return null
  return <>{formatDate(timestamp, format)}</>
}

FormattedDate.defaultProps = {
  format: 'dd MM yyyy',
}

FormattedDate.propTypes = {
  format: PropTypes.string.isRequired,
  timestamp: PropTypes.number,
}

export default FormattedDate
